module.exports = __webpack_public_path__ + "static/img/kf2.ef0c869a.png";